import { SettingsPermissions } from "@redotech/account-common/permissions";
import { PermissionedRouteObject } from "@redotech/redo-merchant-app-common/routing/protected-routes";

export const warrantySettingsRoutes: PermissionedRouteObject[] = [
  {
    handle: {
      breadcrumb: "Registration",
      permission: SettingsPermissions.SET_WARRANTY_SETTINGS,
    },
    path: "registrations",
    lazy: async () => {
      const { WarrantyRegistrationSettings } =
        await import("../../../../setting/registration-settings");
      return { element: <WarrantyRegistrationSettings /> };
    },
  },
  {
    handle: {
      breadcrumb: "Registration Rewards",
      permission: SettingsPermissions.SET_WARRANTY_SETTINGS,
    },
    path: "registration-rewards",
    lazy: async () => {
      const { RegistrationRewards } =
        await import("../../../../setting/registration-rewards");
      return { element: <RegistrationRewards /> };
    },
  },
];
